'use strict';
(() => {
  const strings = JSON.parse(document.querySelector('#baba-i18n')?.textContent || '{}');
  function initialize(scope = document) {
    scope.querySelectorAll('[data-baba-stories]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const filters = [...root.querySelectorAll('[data-filter]')];
      const cards = [...root.querySelectorAll('.card')];
      filters.forEach(button => button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let visible = 0;
        cards.forEach(card => {
          const show = filter === 'all' || card.dataset.categories.split(' ').includes(filter);
          card.hidden = !show;
          if (show) visible++;
        });
        const status = root.querySelector('[data-filter-status]');
        if (status) status.textContent = (visible === 1 ? strings.story_one : strings.story_many).replace('__count__', String(visible));
      }));
    });
    scope.querySelectorAll('[data-baba-connect]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const dialog = root.querySelector('dialog');
      const form = root.querySelector('[data-inquiry-form]');
      const output = root.querySelector('.copy-output');
      const message = root.querySelector('[data-prepared-message]');
      const status = root.querySelector('[data-inquiry-status]');
      let opener;
      root.querySelectorAll('[data-inquiry]').forEach(button => button.addEventListener('click', () => {
        opener = button;
        form.elements.type.value = button.dataset.inquiry;
        output.hidden = true;
        dialog.showModal();
      }));
      root.querySelector('.close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
      form.addEventListener('submit', event => {
        event.preventDefault();
        const values = new FormData(form);
        const name = String(values.get('name')).trim();
        const idea = String(values.get('idea')).trim();
        const details = String(values.get('details')).trim();
        if (!name || !idea) return;
        const type = form.elements.type.selectedOptions[0].textContent.toLowerCase();
        const replacements = {'__name__': name, '__type__': type, '__idea__': idea, '__details__': details ? `\n\n${strings.details} ${details}` : ''};
        message.value = strings.message.replace(/__name__|__type__|__idea__|__details__/g, token => replacements[token]);
        output.hidden = false;
        status.textContent = strings.ready;
        output.scrollIntoView({block: 'nearest'});
        message.focus();
      });
      root.querySelector('[data-copy-message]').addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(message.value);
          status.textContent = strings.copied;
        } catch {
          message.focus();
          message.select();
          status.textContent = strings.selected;
        }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
